import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { pathPickQueryApi } from "@/features/pathpick/api/query";
import { PathPickRequestDetailParams } from "@/features/pathpick/types/request-params";
import { PathPickRequestDetailResponse } from "@/features/pathpick/types/response";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 연동/다운로드 요청 단건 상세 조회 훅 — requestId가 없으면(모달 미오픈 등) 조회하지 않는다.
// 상품별 처리 항목(items)은 서버 페이지네이션 대상이라 페이지 전환 시
// 이전 목록을 유지해(keepPreviousData) 전체 플래시를 막는다.
//
// 쿼리 키는 ["pathpick","requests",companyId] 를 prefix로 유지해야
// 요청 생성/연동 해제 뮤테이션의 무효화가 이 쿼리까지 덮는다.
const useGetPathPickRequestDetail = (
  requestId?: number,
  params?: PathPickRequestDetailParams
) => {
  const { companyId } = useCompanyIdentity();

  const {
    data: pathPickRequestDetail,
    isPending,
    isPlaceholderData,
  } = useQuery({
    queryKey: ["pathpick", "requests", companyId, requestId, params],
    queryFn: async () => {
      const data = await pathPickQueryApi.getPathPickRequestDetail(
        companyId as number,
        requestId as number,
        params
      );
      return toCamelKeyObject(data) as PathPickRequestDetailResponse;
    },
    enabled: Boolean(companyId) && Boolean(requestId),
    placeholderData: keepPreviousData,
  });

  return { pathPickRequestDetail, isPending, isPlaceholderData };
};

export default useGetPathPickRequestDetail;
